import { render } from "./messagesGame.vue?vue&type=template&id=d1d9b07e"
import script from "./messagesGame.vue?vue&type=script&lang=js"
export * from "./messagesGame.vue?vue&type=script&lang=js"

import "./messagesGame.vue?vue&type=style&index=0&id=d1d9b07e&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__